"use client";
import * as React from "react";
const SvgCloseOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M16 1.61 14.39 0 8 6.39 1.61 0 0 1.61 6.39 8 0 14.39 1.61 16 8 9.61 14.39 16 16 14.39 9.61 8z" }));
export {
  SvgCloseOutlined as default
};
